import Phaser from 'phaser';

/** Resets browser zoom to 1x and locks it before starting GameScene, so Scale.FIT calculates correctly. */
export function startGameScene(scene: Phaser.Scene, data: object): void {
  const vp = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null;
  if (vp) vp.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
  requestAnimationFrame(() => {
    scene.scale.refresh();
    scene.scene.start('GameScene', data);
  });
}
